import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ReservationComplete } from '../../components/ReservationComplete';

export const DinnerReservationComplete: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { logout } = useAuth();

    const reservationData = location.state?.reservationData;
    const dinnerTime = reservationData?.dinnerTime?.substring(0, 5) || '-';

    const description = (
        <>
            <span className="highlight">{dinnerTime}</span> 석식 신청이 완료되었습니다.
        </>
    );

    const instruction = (
        <>
            <strong>{dinnerTime}</strong> 에 맞춰 식사 장소로 이동해주세요
        </>
    );

    const handleMain = () => {
        navigate('/selection');
    };

    const handleLogout = async () => {
        await logout();
    };

    return (
        <ReservationComplete
            title="석식 신청 완료"
            description={description}
            instruction={instruction}
            onMain={handleMain}
            onLogout={handleLogout}
        />
    );
};
